import { OverlayContainer } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { ContextTooltipContainerDirectiveToken } from '../consts';

@Injectable()
export class ContextTooltipOverlayContainer extends OverlayContainer {
  constructor(
    @Inject(DOCUMENT) document: Document,
    private platform: Platform,
    private containerDirective: ContextTooltipContainerDirectiveToken,
  ) {
    super(document, platform);

    this._containerElement = this.containerDirective.container;
  }
}
